import { createContext } from 'react';

// Shared context — split from ToastProvider so useToast can import without
// pulling in the provider's DOM dependency in unrelated test files.
const ToastContext = createContext(null);

export default ToastContext;
